// The suggestion editor's own keys, for its CodeMirror view and its
// plain-textarea fallback alike.
import { composing } from './chord';

export type EditorKey = 'submit' | 'escape' | 'indent' | 'outdent';

type KeyLike = Pick<KeyboardEvent, 'key' | 'shiftKey' | 'altKey' | 'ctrlKey' | 'metaKey' | 'isComposing'> & { keyCode?: number };

/**
 * What a key asks the suggestion editor to do: Mod+Enter submits the
 * comment, Esc returns to it, Tab and Shift+Tab indent and outdent the
 * selected lines. Null for any other key, and for every key of an IME
 * composition (its Esc cancels the candidate, its Enter commits it).
 */
export function editorKey(e: KeyLike): EditorKey | null {
  if (composing(e)) return null;
  if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') return 'submit';
  const mods = e.metaKey || e.ctrlKey || e.altKey;
  if (e.key === 'Escape' && !mods) return 'escape';
  if (e.key === 'Tab' && !mods) return e.shiftKey ? 'outdent' : 'indent';
  return null;
}
